<template>
    <div>
      <h2>
        <span class="step-name">
          Dry-Off Process
        </span>
        <comments field-name="heading_dryoff_process"  :isReadOnly="isReadOnly"></comments>
      </h2>

      <div class="step-section">
        <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

          <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
            <h3>{{ farm.farm_label }}</h3>

            <radio-input label="Do you want to teatseal only?"
                         :field-name="`farm_${farm.id}-wants_teat_seal_only`"
                         :choices="[
                                    {value: 'Yes', display: 'Yes'},
                                    {value: 'No', display: 'No'},
                                    ]"
                         :disabled="isReadOnly">
            </radio-input>

            <radio-input label="Vetsouth application?"
                         :field-name="`farm_${farm.id}-wants_vs_application`"
                         @on-change="checkAndCompleteStep"
                         required
                         :choices="[
                                    {value: 'Yes', display: 'Yes'},
                                    {value: 'No', display: 'No'},
                                    ]"
                         :disabled="isReadOnly">
            </radio-input>
            <span class="text-danger" v-if="getFieldValue(`farm_${farm.id}-wants_vs_application`) == 'No'">
              Please provide the client with a paper copy of the Internal Teatseal Checklist document.
            </span>

          </div>
        </div>
      </div>
      <div class="step-section text-left row" v-if="wantsVetsouth">
        <div class="col-md-10 col-md-offset-1">
          <h3> Before vet techs arrive to insert products please consider the following </h3>
          <ol>
            <li>Ensure that a few weeks out from DCT/Combo/Sealant insertion you trim tails and if possible singe udders</li>
            <li>Ensure you have taken out new mastitis cases that have occurred since last herd test and/or the sealant only cow list was made</li>
            <li>Remove all three titters, poor teat condition and empty cows from the sealant only list</li>
            <li>Ensure you strip and ideally RMT the cows during their last milking before dry off</li>
            <li>Separated the DCT/Combo cows out from the sealant only cows</li>
            <li>If cows don't get sealant/DCT/combo whilst milking, ensure they go back to a paddock with roughage on offer to get them full</li>
            <li>Record cows that have been dried off with the product they received; in particular if they were treated with DCT instead of sealant only (if they were in sealant only group)</li>
          </ol>
        </div>
      </div>

      <hr>

      <div class="step-section">
        <h3> Dry off areas discussion </h3>
        <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

          <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
            <h3>{{ farm.farm_label }}</h3>

            <discussion-points title="Pre dry off areas comments"
                               :comments-field="`farm_${farm.id}-pre_dry_off_areas_comments`"
                               points="Nutrition – incl on crop pre dry off or not?
                                       Milking frequency
                                       Weather
                                       Resource & staff capability
                                       Numbers and plan">
            </discussion-points>

            <discussion-points title="Post dry off areas comments"
                               :comments-field="`farm_${farm.id}-post_dry_off_areas_comments`"
                               points="Teatspray
                                       Transport vs home on crop; and when after dry off?
                                       Indoor wintering facility?
                                       Nutrition
                                       Checking cows
                                       General management
                                       Staff capability/holidays/training">
            </discussion-points>
            <discussion-points title="Wintering and Crop"
                               :comments-field="`farm_${farm.id}-wintering_and_crop_comments`"
                               points="Are cows wintered on crop? What type of crop? When are the cows going to be on this crop? 
                                       Are cows wintered off dairy platform? If yes, how will they be transported?">
            </discussion-points>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapMutations } from 'vuex'

export default {
  name: 'DryOffProcess',
  mixins: [ baseComponent ],
  created()
  {
    this.removeRequiredFields({
      stepName: 'DryOffProcess',
      value: ['wants_vs_application']
    })
    let requiredFields = this.getFieldValue('FARMS', 'DryOffProcess').map(farm => `farm_${farm.id}-wants_vs_application`)
    this.addRequiredFields({
      stepName: 'DryOffProcess',
      value: requiredFields
    })
  },
  methods: {
    ...mapMutations('currentConsult', ['addRequiredFields', 'removeRequiredFields']),
    validate: function ()
    {
      return this.getFieldValue('FARMS', 'DryOffProcess').every(farm => Boolean(this.getFieldValue(`farm_${farm.id}-wants_vs_application`, 'DryOffProcess')))
    },
  },
  computed: {
    wantsVetsouth: function() {
      return this.getFieldValue('FARMS').some(farm => this.getFieldValue(`farm_${farm.id}-wants_vs_application`, 'DryOffProcess') == 'Yes')
    },
  },
}
</script>
